import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../components/PageLoader";
import { selectDBNCategoryProductMappingsListItems } from "../../../../../../redux/dbn-category-product-mappings/selector";
import { products } from "../../../../../../redux/products/action";
import { dbnCategoryProductMappings } from "../../../../../../redux/dbn-category-product-mappings/action";

const DBNCategoryProductMappings = ({ category }) => {
  console.log('selected dbn category', category)
  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [searchCriteriaList, setSerchCriteriaList] = useState<any>([]);
  const dbnCategoryProuctMappingsListData = useSelector(selectDBNCategoryProductMappingsListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },      
      { field: 'IsAvailable', headerName: 'vailable', cellRenderer: 'yesNoRenderer' },
      { field: 'IsPublished', headerName: 'Published', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

    const fetchCategoryMappedProductsList = () => {
      dispatch(dbnCategoryProductMappings.list({
        url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/products/fetch`,
        entity: 'products',
        jsonData:
        {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "ProductId",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "Category",
              "FilterOperatorId": 1,
              "FieldValue": category?.Name,
              "FieldType": "text"
            }
          ],
          "Searches": searchCriteriaList
        }
      }))
    }

  const handleReloadData = () => {
    setSerchCriteriaList([])
    fetchCategoryMappedProductsList();
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Category",
        FieldText: "Category",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    setSerchCriteriaList(searchCriteria)
    fetchCategoryMappedProductsList();
  }

  useEffect(() => {
    createColumnDefs();
    fetchCategoryMappedProductsList();
  }, [pageData, pageSize, searchCriteriaList])

  return (
    <>
      {dbnCategoryProuctMappingsListData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} 
          rowData={dbnCategoryProuctMappingsListData?.result?.items}
          setPageData={setPageData} 
          setPageSize={setPageSize} 
          searchCriteriaList={searchCriteriaList}
          paginationData={dbnCategoryProuctMappingsListData?.result?.pagination}
          enableFilter={true} 
          onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'ProductId',
          }}
          additionButtons={additionButtons}
          headingName="Category Product Mappings"
        />
      }
    </>
  );
};

export default DBNCategoryProductMappings;


